export const round = (number) => {
	return Math.round(number * 100) / 100;
};
